import { render, staticRenderFns } from "./limit-list.vue?vue&type=template&id=6d9445ec&scoped=true&"
import script from "./limit-list.vue?vue&type=script&lang=ts&"
export * from "./limit-list.vue?vue&type=script&lang=ts&"
import style0 from "./limit-list.vue?vue&type=style&index=0&id=6d9445ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9445ec",
  null
  
)

export default component.exports